'use client'

import { useEffect } from 'react'
import { useAtom } from 'jotai'

import NavMobileToggle from '@/components/nav/primary/NavMobileToggle'
import NavPrimaryItem from '@/components/nav/primary/NavPrimaryItem'

import { trackStateAtom, activeStateAtom, mobileStateAtom } from '@/components/nav/primary/state'

export default function NavPrimaryTrack({ data }): JSX.Element | null {
  const [trackVisible, setTrackVisible] = useAtom(trackStateAtom)
  const [active, setActive] = useAtom(activeStateAtom)
  const [mobileActive, setMobileActive] = useAtom(mobileStateAtom)

  useEffect(() => {
    if (trackVisible) {
      document.body.classList.add('l:lock-body')
    } else {
      document.body.classList.remove('l:lock-body')
    }
  }, [trackVisible])

  // xl-up gap reduced to compensate for bold pseudo element
  const trackClass = `
    xl-up:gap-xl

    l-up:flex
    l-up:gap-l

    l:overflow-y-auto
    l:overflow-x-hidden
  `

  const primaryNavItems =
    data && Object.values(data).length
      ? Object.values(data).map(({ id, url, title, acf }) => (
          <li key={`menu-primary-item${id}`} className="l-up:flex">
            <NavPrimaryItem
              key={`menu-primary-item${id}`}
              id={id}
              url={url}
              title={title}
              acf={acf}
              active={active}
              setActive={setActive}
              mobileActive={mobileActive}
              setMobileActive={setMobileActive}
              onClick={() => {
                setActive(null)
                setTrackVisible(false)
              }}
            />
          </li>
        ))
      : []

  if (!primaryNavItems?.length) {
    return null
  }

  const trackActiveClass = trackVisible ? 'track-active' : 'track-inactive'

  return (
    <>
      <ul className={`${trackClass} ${trackActiveClass}`}>{primaryNavItems}</ul>

      <NavMobileToggle />
    </>
  )
}
